import { render } from "./DevelopmentRoadmap.vue?vue&type=template&id=755a43d8&scoped=true"
import script from "./DevelopmentRoadmap.vue?vue&type=script&lang=js"
export * from "./DevelopmentRoadmap.vue?vue&type=script&lang=js"

import "./DevelopmentRoadmap.vue?vue&type=style&index=0&id=755a43d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755a43d8"]])

export default __exports__